import { render, staticRenderFns } from "./admin_articles_by_milestone.vue?vue&type=template&id=27f7767f&scoped=true"
import script from "./admin_articles_by_milestone.vue?vue&type=script&lang=js"
export * from "./admin_articles_by_milestone.vue?vue&type=script&lang=js"
import style0 from "./admin_articles_by_milestone.vue?vue&type=style&index=0&id=27f7767f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f7767f",
  null
  
)

export default component.exports